import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IResidues, IAskForResidue, IApplicants, IDenyResidue, IDonateResidue, IAddResiduesForm } from '../interfaces';
import { HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class ResiduesService {
   readonly url='https://us-central1-residuoscriativos.cloudfunctions.net/app';
    readonly token = localStorage.getItem('token');
    readonly headersWithToken = new HttpHeaders()
    .set('content-type', 'application/json')
    .set('x-access-token', this.token);

  constructor(private http: HttpClient) { }

  getResidues() {
    return this.http.get<IResidues[]>(`${this.url}/residue`, {headers: this.headersWithToken});
  }

  donateResidue(payload: IDonateResidue) {
    return this.http.put(`${this.url}/residue/request`, payload, {headers: this.headersWithToken});
  }

  denyResidue(payload: IDenyResidue) {
    return this.http.put(`${this.url}/residue/failed`, payload, {headers: this.headersWithToken});
  }

  askForResidue(payload: IAskForResidue) {
    return this.http.put<IResidues[]>(`${this.url}/residue/request`, payload, {headers: this.headersWithToken});
  }

  getAppliedResidues() {
    return this.http.get<IApplicants[]>(`${this.url}/residue/request`, {headers: this.headersWithToken});
  }

  getResidueImage(imageName: string) {
    return this.http.get(`${this.url}/file/signedurl/${imageName}`);
  }

  uploadResidueImage(image: File){
    const formData: FormData = new FormData();
    formData.append('file', image);
    return this.http.post(`${this.url}/file/upload`, formData);
  }

  addResidue(payload : IAddResiduesForm){
    return this.http.post(`${this.url}/residue`, payload, {headers: this.headersWithToken});
  }
}